import { typeComplaint } from "./complaint"
import { mutationCreateComplaint } from "./mutations/mutationCreateComplaint"
import { mutationDeleteComplaint } from "./mutations/mutationDeleteComplaint"
import { mutationUpdateComplaint } from "./mutations/mutationUpdateComplaint"
import { queryComplaint } from "./queries/queryComplaint"
import { queryComplaintAvailableApplications } from "./queries/queryComplaintAvailableApplications"
import { queryComplaintAvailableDefects } from "./queries/queryComplaintAvailableDefects"
import { queryComplaintCustomerClaims } from "./queries/queryComplaintCustomerClaims"
import { queryComplaints } from "./queries/queryComplaints"

const complaintSchema = {
  types: [typeComplaint],
  resolvers: {
    Query: {
      ...queryComplaints,
      ...queryComplaint,
      ...queryComplaintAvailableApplications,
      ...queryComplaintAvailableDefects,
      ...queryComplaintCustomerClaims,
    },
    Mutation: {
      ...mutationCreateComplaint,
      ...mutationUpdateComplaint,
      ...mutationDeleteComplaint,
    },
  },
}

export default complaintSchema
